export default __webpack_public_path__ + "static/media/3a36511b-f91c-4789-9905-1cdbd19147c3.5a546c55.png";